import { createFileRoute } from '@tanstack/react-router';
import { validateGuardsOrRedirect, GuardKeyBuilder } from 'common/guards';
import LoggedInRoutesPanel from 'features/loggedInRoutesPanel';
import { ConnectPage } from 'pages/connect';

export const Route = createFileRoute('/spaces/connect')({
  beforeLoad: async () => {
    await validateGuardsOrRedirect([GuardKeyBuilder.featureFlag('SYSAID_CONNECT_ENABLED')]);
  },
  component: () => (
    <LoggedInRoutesPanel>
      <ConnectPage />
    </LoggedInRoutesPanel>
  ),
});
